import { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '../ui/dialog';
import { useAuth } from '../../context/AuthContext';
import api, { apiError } from '../../lib/api';
import { toast } from 'sonner';

const inputCls = 'w-full h-11 px-4 rounded-xl bg-bh-canvas border border-white/10 text-sm placeholder:text-gray-600 focus:outline-none focus:border-bh-accent/60 transition-colors';

export default function TelegramBind() {
  const { tgBindOpen, closeTelegramBind, updateUser, user } = useAuth();
  const [code, setCode] = useState('');
  const [tgCfg, setTgCfg] = useState({ bot_link: null, enabled: false });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!tgBindOpen) return;
    setCode('');
    setError('');
    api.get('/auth/telegram-config').then((r) => setTgCfg(r.data)).catch(() => {});
  }, [tgBindOpen]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { data } = await api.post('/auth/telegram/bind', { code });
      updateUser(data);
      toast.success(data.telegram_username ? `@${data.telegram_username} bağlandı` : 'Telegram bağlandı');
      closeTelegramBind();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (user?.telegram_verified) return null;

  return (
    <Dialog open={tgBindOpen} onOpenChange={(o) => !o && closeTelegramBind()}>
      <DialogContent className="bg-bh-surface border-white/10 text-bh-txt sm:max-w-md p-0 overflow-y-auto" data-testid="telegram-bind-modal">
        <form onSubmit={submit} className="p-5 sm:p-6 space-y-4">
          <div className="text-center">
            <h2 className="font-display font-extrabold text-lg">Telegram bağla</h2>
            <p className="text-xs text-gray-500 mt-1">Çark, görev, promo ve market için botta /start yaz, gelen kodu buraya gir. Profilinden de bağlayabilirsin.</p>
          </div>
          {tgCfg.bot_link && (
            <a
              href={tgCfg.bot_link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="telegram-bind-bot-link"
              className="flex items-center justify-center h-11 rounded-xl btn-ghost text-sm font-semibold"
            >
              Botu aç — /start
            </a>
          )}
          <input
            data-testid="telegram-bind-code"
            className={`${inputCls} tracking-[0.3em] text-center font-semibold`}
            placeholder="6 haneli kod"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            inputMode="numeric"
            maxLength={8}
            required
          />
          {error && <p data-testid="telegram-bind-error" className="text-xs text-bh-crimson bg-bh-crimson/10 border border-bh-crimson/30 rounded-lg px-3 py-2">{error}</p>}
          <button data-testid="telegram-bind-submit" type="submit" disabled={busy} className="w-full btn-accent py-3 rounded-xl text-sm disabled:opacity-50">
            {busy ? 'Kontrol ediliyor...' : 'Bağla'}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
